import controller from './organization-alert-config.controller';

const template = require('./organization-alert-config.html');

export default {
    controller,
    template
}; 